$(document).ready(function () {
    var _table = $('.table-filter');

    _table.on('change propertychange keyup', function() {
        var _searchable = $('.table-searchable tr');
        var val = $(this).val();
        val = val && val.replace(new RegExp("[({[^.$*+?\\\]})]", "g"), '');
        var rex = new RegExp(val, 'i');
        _searchable.hide();
        _searchable.filter(function () {
            return rex.test($(this).text());
        }).show();
    });

    if (_table.val() != '') {
        _table.change();
    }
});